import { createFileRoute, useLocation } from '@tanstack/react-router'

import { usePapeis } from '@/lib/sessao'
import { inicioDoPerfil, perfilDaPessoa } from '@/lib/visoes'

import { Redirecionar } from '@/components/layout/redirecionar'

export const Route = createFileRoute('/')({
  component: Inicio,
})

/** Endereço raiz (`/`): abre a visão da pessoa (a do papel dela). A query segue junto. */
function Inicio() {
  const papeis = usePapeis()
  const { searchStr } = useLocation()
  const destino = inicioDoPerfil(perfilDaPessoa(papeis), papeis)
  return <Redirecionar para={`${destino}${searchStr}`} />
}
